/**
 * Merge multiple abort signal into a single one that aborts as soon as any of the provided signal aborts
 */
export function mergeSignals(signals: Array<AbortSignal | undefined>): AbortSignal {
    const controller = new AbortController();
    for (const signal of signals) {
        if (signal) {
            signal.addEventListener('abort', controller.abort);
        }
    }
    return controller.signal;
}
